import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
import { get, parseInt as _parseInt, cloneDeep } from 'lodash';
import vueSetPath from '@/utilities/vueSetPath';
let CharacterSheetTweaker = class CharacterSheetTweaker extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.myGet = get;
        this.myTweaks = {};
    }
    get diceSizes() {
        return [4, 6, 8, 10, 12].map(value => ({ text: 'd' + value, value }));
    }
    resetValues() {
        this.myTweaks = cloneDeep(this.tweaks);
    }
    sanitize(value) {
        const sanitizedValue = _parseInt(value);
        return isNaN(sanitizedValue) ? null : sanitizedValue;
    }
    updateTweak(newValue, tweakType, path) {
        vueSetPath(this.myTweaks, `${path}.${tweakType}`, this.sanitize(newValue));
        if (tweakType !== 'dieSize') {
            const otherTweakType = tweakType === 'override' ? 'bonus' : 'override';
            vueSetPath(this.myTweaks, `${path}.${otherTweakType}`, null);
        }
    }
    updateProficiency(newValue, path) {
        vueSetPath(this.myTweaks, `${path}.proficiency`, newValue);
    }
    handleSave() {
        this.$emit('replaceCharacterProperty', { path: this.rootPath, property: this.myTweaks });
        this.isOpen = false;
    }
};
__decorate([
    Prop(Object)
], CharacterSheetTweaker.prototype, "tweaks", void 0);
__decorate([
    Prop(Array)
], CharacterSheetTweaker.prototype, "tweakPaths", void 0);
__decorate([
    Prop(String)
], CharacterSheetTweaker.prototype, "title", void 0);
__decorate([
    Prop({ default: 'tweaks', type: String })
], CharacterSheetTweaker.prototype, "rootPath", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetTweaker.prototype, "noStyle", void 0);
CharacterSheetTweaker = __decorate([
    Component({
        components: {
            MyDialog
        }
    })
], CharacterSheetTweaker);
export default CharacterSheetTweaker;
